import { render } from "./OrderSummary.vue?vue&type=template&id=4cbbffe4"
import script from "./OrderSummary.vue?vue&type=script&lang=js"
export * from "./OrderSummary.vue?vue&type=script&lang=js"

import "./OrderSummary.vue?vue&type=style&index=0&id=4cbbffe4&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__